<template>
  <div class="flex flex-wrap">
    <label
      class="block px-2 my-2 font-headline font-sm font-medium leading-loose"
      v-for="formInput in formInputs"
      :key="formInput.name"
      :class="getClasses(formInput)"
    >
      <div v-if="formInput.label">
        {{ formInput.label }}<span v-if="isRequired(formInput)">*</span>
      </div>

      <ValidationProvider
        ref="ValidationProvider"
        :name="formInput.name"
        :rules="getValidationRules(formInput)"
        v-slot="{ errors }"
      >
        <select
          :name="formInput.name"
          v-model="formInput.value"
          v-if="formInput.type === 'select'"
          :class="{ 'border-red-500 error focus:border-0': errors[0] }"
          @change="onChange($event)"
          class="w-full border focus:outline-none focus:border-primary-lighter bg-white text-gray-500 transition-all duration-200 ease-in-out border-gray h-10 rounded-full pl-6"
        >
          <option class="text-gray-500" value selected disabled hidden>
            {{ formInput.placeholder }}
          </option>
          <option
            v-for="(option, key) in formInput.options"
            :key="key"
            :value="key"
            >{{ option }}</option
          >
        </select>

        <textarea
          :name="formInput.name"
          v-if="formInput.type === 'textarea'"
          v-model="formInput.value"
          class="w-full h-64 border border-gray focus:outline-none rounded py-4 md:px-8 placeholder-gray rounded-text-area pl-6"
          :class="{ 'border-red-500 error focus:border-0': errors[0] }"
          :placeholder="formInput.placeholder"
        ></textarea>

        <input
          :name="formInput.name"
          v-model="formInput.value"
          type="text"
          v-if="formInput.type === 'text'"
          :placeholder="formInput.placeholder"
          :class="{ 'border-red-500 error focus:border-0': errors[0] }"
          class="w-full border border-gray rounded focus:outline-none focus:border-primary-lighter transition-all duration-200 ease-in-out h-10 placeholder-gray rounded-full pl-6"
        />
        <input
          :name="formInput.name"
          v-model="formInput.value"
          type="number"
          v-if="formInput.type === 'number'"
          :placeholder="formInput.placeholder"
          :class="{ 'border-red-500 error focus:border-0': errors[0] }"
          class="w-full border border-gray rounded focus:outline-none focus:border-primary-lighter h-10 transition-all duration-200 ease-in-out placeholder-gray rounded-full pl-6"
        />
        <input
          :name="formInput.name"
          v-model="formInput.value"
          type="email"
          v-if="formInput.type === 'email'"
          :placeholder="formInput.placeholder"
          :class="{ 'border-red-500 error focus:border-0': errors[0] }"
          class="w-full border border-gray rounded focus:outline-none focus:border-primary-lighter h-10 transition-all duration-200 ease-in-out placeholder-gray rounded-full pl-6"
        />
        <input
          :name="formInput.name"
          v-model="formInput.value"
          type="phone"
          ref="phone"
          v-if="formInput.type === 'phone'"
          :placeholder="formInput.placeholder"
          :class="{ 'border-red-500 error focus:border-0': errors[0] }"
          class="w-full border border-gray rounded focus:outline-none focus:border-primary-lighter transition-all duration-200 ease-in-out h-10 placeholder-gray rounded-full pl-6"
        />
        <div
          v-if="formInput.type === 'checkbox'"
          class="inline-flex items-center w-full"
        >
          <input
            :name="formInput.name"
            type="checkbox"
            v-model="formInput.value"
            class="hidden"
          />
          <span
            class="w-16px h-16px new-box bg-white mr-2 border border-grey rounded"
            :class="{ 'border-red-500 error focus:border-grey': errors[0] }"
          ></span>
          <span
            class="font-light w-11/12 text-sm"
            v-html="formInput.content"
          ></span>
        </div>
      </ValidationProvider>
    </label>
  </div>
</template>

<script>
import { ValidationProvider, Validator } from "vee-validate";
import "./Validators";
import countryCodes from "./countries-numbers.js";
import { find } from "lodash";

export default {
  name: "HiFormParser",
  props: {
    formInputs: {
      type: [Array, Object],
      required: true,
    },
  },
  components: {
    ValidationProvider,
  },
  // computed: {
  //   formErrors() {
  //     const errors = this.$validator.errors;

  //     return errors;
  //   },
  // },

  // watch: {
  //   formErrors: {
  //     handler(value) {
  //       console.log(value);
  //       return this.$emit("form-errors", value);
  //     },

  //     deep: true,
  //   },
  // },
  methods: {
    getClasses(formInput) {
      if (
        formInput.type === "textarea" ||
        formInput.type === "checkbox" ||
        formInput.type === "email"
      ) {
        return "w-full";
      } else {
        return "md:w-1/2 w-full";
      }
    },
    getValidationRules(formInput) {
      if (!formInput.validators) {
        return null;
      }

      if (Array.isArray(formInput.validators)) {
        return formInput.validators.join("|");
      }
      return formInput.validators;
    },
    isRequired(formInput) {
      return formInput.validators && formInput.validators.includes("required");
    },
    onChange(event) {
      const selectedCountry = find(countryCodes.countries, (country) => {
        return country.code == event.target.value;
      });

      this.$refs.phone[0].value = selectedCountry.dialCode;
    },
  },
};
</script>

<style scoped>
option:not(:first-of-type) {
  color: #475677;
}
input[type="radio"] + .new-box,
input[type="checkbox"] + .new-box {
  transition: all 0.2s;
}

input[type="radio"] + .new-box:hover,
input[type="checkbox"] + .new-box:hover,
label:hover input[type="radio"] + .new-box,
label:hover input[type="checkbox"] + .new-box {
  transform: scale(1.2);
}

input[type="radio"]:checked + .new-box,
input[type="checkbox"]:checked + .new-box {
  background-color: #ea7415;
}
</style>
